import { SVGICON } from "../../constant/theme";

export const StaffMenuList = [
    {
        title: 'Dashboard',
        iconStyle: SVGICON.Home,
        to: '/dashboard',

    },
    {
        title: 'Builders',
        iconStyle: SVGICON.Pages,
        to: '/filterbuilder',

    },
    {
        title: 'Subdivisions',
        iconStyle: SVGICON.Finance,
        to: '/filtersubdivision',
    },

    {
        title: 'Products',
        iconStyle: SVGICON.CoreHr,
        to: '/filterproducts',
    },

    {
        title: 'Permits',
        iconStyle: SVGICON.Performance,
        to: '/filterpermits',
    },

    {
        title: 'Weekly Traffic & Sales',
        iconStyle: SVGICON.GridDots,
        to: '/filterweeklytrafficandsales',
    },
    {
        title: 'Base Prices',
        iconStyle: SVGICON.Pages,
        to: '/filterbaseprice',

    },
    {
        title: 'Closings',
        iconStyle: SVGICON.CoreHr,
        to: '/filterclosings',
    },
    {
        title: 'Land Sales',
        iconStyle: SVGICON.ProjectsSidbar,
        to: '/filterlandsales',
    },
    {
        title: 'Reports',
        iconStyle: SVGICON.GridDots,
        to: '/report',
    },
    {
        title: 'Files',
        iconStyle: SVGICON.Finance,
        to: '/files',
    },

    {
        title: 'Users',
        iconStyle: SVGICON.User,
        to: '/userlist',
    },
    {
        title: 'Data Reporting',
        iconStyle: SVGICON.GridDots,
        to: '/weekly-data',
    },
    {
        title: 'Archive Data',
        iconStyle: SVGICON.ArchiveData,
        to: '/downloading-archive-data',
    },
]